<p-iconField>
  <p-inputIcon styleClass="fas fa-book-open"></p-inputIcon>

  <p-multiSelect
    [selectedItemsLabel]="selectedTopics?.length + ' Themen ausgewählt'"
    [styleClass]="styleClass"
    *ngIf="topicStore.sorted() as topics"
    class="w-20rem"
    [placeholder]="label"
    (ngModelChange)="onTopicsChange()"
    [options]="topics"
    [(ngModel)]="selectedTopics"
    [showClear]="true"
    optionLabel="title"
    optionValue="_id"
    dataKey="_id">
    <ng-template let-item pTemplate="item">
      <div class="flex align-items-center gap-2">
        <i [class]="'fas fa-' + item.icon"></i>
        <div>{{ item.title }}</div>
      </div>
    </ng-template>
  </p-multiSelect>
</p-iconField>
